export interface TextstringReplacement {
    [key: string]: string;
}

export interface ITextstring {
    fallback: string;
    name: string;
}
